export const getHoneypotConfig = () => ({
  DISABLE_HONEYPOTS: true,
  maxFieldsPerStep: 1
});